import loadingIndicator from '@fino/ng1-loading-indicator';
import { pdfViewerComponent } from './pdf-viewer.component';
import { ngOnload } from './pdf-viewer.directive';

export default angular
  .module('ng1-pdf-viewer', [loadingIndicator])
  .component('pdfViewer', pdfViewerComponent)
  .directive('ngOnload', ngOnload)
  .name;
